/* Live Free · review origin labels (2026-09-28)
 *
 * A Judge.me Product Group shares the Routine Set's reviews across the Routine Set,
 * the Starter Set, smooth sali, pore magic and moisturose. That is deliberate, but a
 * shopper reading pore magic should not be shown a review written about a different
 * product with nothing saying so.
 *
 * Judge.me already ships the answer in its own markup: every .jdgm-rev carries
 * data-product-title and data-product-url. The main review widget just never prints
 * them. This adds "Review for: <product>" to any review whose product is not the one
 * being viewed, using Judge.me's own data. Reviews written about THIS product get no
 * label, so the line only ever appears where it is telling the truth.
 *
 * The widget re-renders on sort, filter and paginate, so this watches for that.
 */
(function () {
  'use strict';

  function decode(s) {
    var t = document.createElement('textarea');
    t.innerHTML = String(s == null ? '' : s);
    return t.value;
  }
  function norm(s) {
    return decode(s).replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function label(root) {
    var here = norm(root.getAttribute('data-lf-review-origin'));
    if (!here) return;

    var revs = root.querySelectorAll('.jdgm-rev[data-product-title]');
    for (var i = 0; i < revs.length; i++) {
      var rev = revs[i];
      var title = rev.getAttribute('data-product-title');
      var existing = rev.querySelector('.lf-revfor');

      /* written about the product being viewed: no label, and clear a stale one */
      if (!title || norm(title) === here) {
        if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
        continue;
      }
      if (existing) continue;

      var url = rev.getAttribute('data-product-url') || '';
      var p = document.createElement('p');
      p.className = 'lf-revfor';
      p.appendChild(document.createTextNode('Review for: '));

      var name = document.createElement(url ? 'a' : 'span');
      name.className = 'lf-revfor__name';
      name.textContent = decode(title);
      if (url) name.setAttribute('href', url);
      p.appendChild(name);

      var content = rev.querySelector('.jdgm-rev__content') || rev;
      content.insertBefore(p, content.firstChild);
    }
  }

  function watch(root) {
    var busy = false;
    var run = function () {
      if (busy) return;
      busy = true;
      try { label(root); } finally {
        /* let our own insertions settle before listening again */
        window.setTimeout(function () { busy = false; }, 0);
      }
    };
    run();
    if (typeof MutationObserver === 'function') {
      new MutationObserver(run).observe(root, { childList: true, subtree: true });
    }
  }

  function init() {
    var roots = document.querySelectorAll('[data-lf-review-origin]');
    for (var i = 0; i < roots.length; i++) watch(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
